/// <reference types="jquery" />

import BoardAutoRefreshCommon = require("Agile/Scripts/Board/BoardsAutoRefreshCommon");
import FeatureAvailability_Services = require("VSS/FeatureAvailability/Services");
import ServerConstants = require("Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.Constants");
import { ScopedEventHelper } from "Agile/Scripts/ScopedEventHelper";
import { AutoRefreshThrottler } from "Agile/Scripts/Common/AutoRefreshThrottler";

export class BoardsAutoRefreshThrottler extends AutoRefreshThrottler {
    private _boardExtensionId: string;

    constructor(boardExtensionId: string, eventsHelper: ScopedEventHelper) {
        super(eventsHelper);
        this._boardExtensionId = boardExtensionId;
        if (this._isFFEnabled) {
            // We are interest is this event only when throttling is enabled.
            this._attachAutoRefreshCompletedEvent();
        }
    }

    protected fireItemsNeedAutoRefresh(workItemDataList: BoardAutoRefreshCommon.BoardsAutoRefreshEventPayload[]) {
        this._eventsHelper.fire(BoardAutoRefreshCommon.Events.ItemsNeedAutoRefresh, this, workItemDataList);
    }

    protected checkFFStatus() {
        return FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(
            ServerConstants.FeatureAvailabilityFlags.WebAccessAgileKanbanBoardAutoRefreshThrottling
        );
    }

    private _attachAutoRefreshCompletedEvent() {
        this.attachAutoRefreshCompletedEvent(BoardAutoRefreshCommon.Events.ItemsAutoRefreshCompleted);
    }

    private _detachAutoRefreshCompletedEvent() {
        this.detachAutoRefreshCompletedEvent(BoardAutoRefreshCommon.Events.ItemsAutoRefreshCompleted);
    }

    public dispose() {
        super.dispose();
        this._detachAutoRefreshCompletedEvent();
    }

    protected logThrottlingStoppedTelemetry() {
        BoardAutoRefreshCommon.PublishAutoRefreshTelemetry("WorkItemsRefreshThrotllingStopped", this._boardExtensionId, {});
    }

    protected logThrottlingStartedTelemetry() {
        var ciData: IDictionaryStringTo<any> = {
            RemainingItemsToRefresh: this.getRemainingItems()
        };
        BoardAutoRefreshCommon.PublishAutoRefreshTelemetry("WorkItemsRefreshThrotllingStarted", this._boardExtensionId, ciData);
    }

    protected logPipelineUnblockedTelemetry() {
        BoardAutoRefreshCommon.PublishAutoRefreshTelemetry("PipelineUnblocked", this._boardExtensionId, {});
    }
}
